// import TIM from 'tim-js-sdk'
import axios from 'axios'
import { INTERACTION_HOSTNAME } from 'common/utils/variables'
import adapter from './wy-adapter'
import { loginApp } from '../../../common/js/common'
import logger from '../../../base/logger'

const ax = axios.create({
  baseURL: `${INTERACTION_HOSTNAME}/interactionCommon/`
})
const axDirect = axios.create({
  baseURL: `${INTERACTION_HOSTNAME}/interactionDirectCall/`
})
ax.defaults.withCredentials = axDirect.defaults.withCredentials = true
const responseInterceptor = response => {
  const appBridge = window.appBridge
  const { data, success, code, info } = response.data
  if (success) {
    return data
  }
  if (code === 401 && appBridge && appBridge.isApp()) {
    loginApp()
  } else {
    return Promise.reject(new Error(code + ': ' + info))
  }
}
ax.interceptors.response.use(responseInterceptor)
axDirect.interceptors.response.use(responseInterceptor)

// adapter.install(TIM)
adapter.quitPresentation = function quitPresentation() {
  return
  // const { pbUuid, roomId } = this.pageContext
  // if (!roomId || !this.dashboard.isInGroup) {
  //   return
  // }
  // this.stopAudioChat()
  // if (andInvalidateRoom) {
  //   ax.get('endInteractionByUser', { params: { pbUuid } })
  // }
  // this.quitGroup()
  // this.logout()
  // Object.assign(this.dashboard, {
  //   isLogin: false,
  //   isInGroup: false
  // })
  // this.pageContext.roomId = null
}
adapter.requestPresenterControl = function requestPresenterControl() {
  // TODO: 对接服务端接口，call ax.post('someApi')
  // const appBridge = window.appBridge
  // const { pbUuid, salesUuid, roomId } = this.pageContext
  // const agentSite = appBridge && appBridge.isApp()
  // ax.post('getControl', { agentSite, salesUuid, pbUuid, groupId: roomId })
}
// TODO: 下载语音
adapter.startAudioChat = async function startAudioChat() {
  if (this.dashboard.isAudioConnected) {
    logger.warn('重复开启音频')
    return true
  }
  this.dashboard.isAudioConnected = true
}
adapter.stopAudioChat = function stopAudioChat() {
  if (!this.dashboard.isAudioConnected) {
    logger.warn('音频未初始化成功无需销毁。或重复销毁音频')
    return
  }
  this.dashboard.isAudioConnected = false
  return this
}

export async function initTim() {
  const tim = adapter
  tim.dashboard = {
    isLogin: true,
    isInGroup: true,
    isAudioConnected: false,
    isSdkReady: true
  }

  // TODO: 调试用
  window.theTim = tim

  // const sdkReadyPromise = new Promise(resolve => {
  //   tim.on(tim.EVENTS.onSdkReady, resolve)
  // })

  // const { userSig, sdkAppId, userId } = await ax.get('userSig/get/')
  // sdkAppId
  // tim.create()
  // await tim.login(userId, userSig)
  // tim.dashboard.isLogin = true

  // const pbUuid = getUrlParam('uuid')

  // let roomId = getUrlParam('roomId')
  // if (roomId) {
  //   logger.warn('[TIM INIT]', 'roomId: ', roomId)
  //   await axDirect.get("directStartForUser", {
  //     params: { pbUuid, groupId:roomId }
  //   });
  // } else {
  //   logger.warn('[TIM INIT]', 'URL roomId 参数为空')
  //   throw new Error("INVALID_ROOMID");
  // }

  // tim.pageContext = { pbUuid, sdkAppId, userId, userSig, avatar, nick, roomId, salesUuid }

  // await sdkReadyPromise
  // tim.dashboard.isSdkReady = true

  // await tim.updateMyProfile({ avatar, nick })
  // String(roomId)
  // await tim.joinGroup()
  // tim.dashboard.isInGroup = true

  return tim
}
